import { constructEnum } from '@/lib/enum';

const WidgetLocale = constructEnum('WidgetLocale', {
  KO_KR: 'ko-KR',
  EN_US: 'en-US',
  JA_JP: 'ja-JP',
  ZH_CN: 'zh-CN',
  ZH_TW: 'zh-TW'
});

WidgetLocale.defaultFontFamily = function(locale) {
  switch (locale) {
    case WidgetLocale.KO_KR:
      return [
        'system-ui',
        'Apple SD Gothic Neo',
        'Noto Sans KR',
        'Malgun Gothic',
        'Nanum Gothic',
        'sans-serif'
      ];
    case WidgetLocale.JA_JP:
      return [
        'system-ui',
        'Meiryo',
        'Hiragino Kaku Gothic ProN',
        'Yu Gothic',
        'Noto Sans JP',
        'sans-serif'
      ];
    case WidgetLocale.ZH_CN:
      return [
        'system-ui',
        'Microsoft YaHei',
        'PingFang SC',
        'Noto Sans SC',
        'sans-serif'
      ];
    case WidgetLocale.ZH_TW:
      return [
        'system-ui',
        'Microsoft JhengHei',
        'PingFang TC',
        'Noto Sans TC',
        'sans-serif'
      ];
    default:
      return [
        'system-ui',
        'Segoe UI',
        'Roboto',
        'Helvetica Neue',
        'sans-serif'
      ];
  }
};

export default WidgetLocale;
